import { css } from "lit";

export const style = css`
  .background {
    display: flex;
    flex-direction: column;
    padding: var(--sds-size-space-150);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    box-shadow: 0 var(--sds-size-space-100) var(--sds-size-space-100) 0 var(--sds-color-black-300);
    text-decoration: none;

    &.small {
      width: 130px;

      & .handle {
        font-size: var(--sds-typography-body-size-small);

        padding: var(--sds-size-space-200) var(--sds-size-space-300);
        margin: var(--sds-size-space-150);
      }
    }

    &.medium {
      width: 260px;

      & .handle {
        font-size: var(--sds-typography-subheading-size);
        padding: var(--sds-size-space-300) var(--sds-size-space-500);
        margin: var(--sds-size-space-200);
      }
    }

    &.large {
      min-width: 390px;
      width: 50vw;

      & .handle {
        font-size: var(--sds-typography-title-page-size);
        padding: var(--sds-size-space-400) var(--sds-size-space-600);
        margin: var(--sds-size-space-300);
      }
    }

    & .image {
      position: relative;
      width: 100%;
      aspect-ratio: 1.2/1;

      &::after {
        content: "";
        background: linear-gradient(transparent 0%, var(--sds-color-background-default-default) 100%);
        position: absolute;
        z-index: 1;
        display: block;
        width: 100%;
        height: 100%;
        top: 0;
      }

      & img,
      & video {
        width: 100%;
        border-radius: var(--sds-size-radius-200);
        aspect-ratio: 1.2/1;
        object-fit: cover;
        object-position: center 40%;
      }
    }

    &.handle-top {
      flex-direction: column-reverse;

      & .image::after {
        background: linear-gradient(var(--sds-color-background-default-default) 0%, transparent 100%);
      }
    }

    & .handle {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
      border-radius: var(--sds-size-radius-200);
      background: var(--sds-color-background-default-secondary);

      color: var(--sds-color-text-default-secondary);

      /* Single Line/Body Small */
      font-family: var(--sds-typography-family-body);
      font-style: normal;
      font-weight: var(--sds-typography-weight-regular);
      line-height: 100%; /* 12px */
    }
  }

  a .handle {
    justify-content: space-between;
  }

  div .handle {
    justify-content: center;
  }
`;
